export const BlexonColor = {
	weldlineColor: 0x0e8025, // grün
	selectionColor: 0xe9052b, //rgb(233, 5, 43)

	//Farbe wenn man mit der Maus über eine Fläche oder eine Linie geht. (aktuell pink)
	hoveredGeometryColor: 0xee00ee,
};
